import React from "react";

import Logo from "../../../assets/images/cellzone_logo.png";
import { useCreateContext } from "../create/provider/create.provider";
import { useCreateNewsContext } from "../create/news/provider/createNews.provider";
import { useCreateUsedContext } from "../create/used/provider/createUsed.provider";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Navbar = () => {
  const { setFlow, setStep, step } = useCreateContext();
  const { handleInitialState: handleInitialStateNews } = useCreateNewsContext();
  const { handleInitialState: handleInitialStateUsed } = useCreateUsedContext();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    setFlow("new");
    handleInitialStateUsed();
    handleInitialStateNews();
    logout();
    setStep(1);
  };

  return (
    <nav className={`fixed z-40 w-full bg-white`}>
      <div className="max-w-screen flex px-32">
        <div className="ml-10 flex w-full items-center justify-between px-5 lg:px-0">
          <div className="my-5 -ml-7 w-32 pt-5 lg:ml-0 lg:w-40 lg:pt-2">
            <img alt="cellzone_logo" src={Logo} className="img-fluid w-full" />
          </div>
          {step > 2 && (
            <div className="text-center">
              <button
                type="button"
                className="text-center"
                onClick={() => handleLogout()}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
